import { DeliveryType } from "./price.model";

export interface OperatorSelection {
    posId?: string;
    operator?: string;
    deliveryType?: DeliveryType;
}
